"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _abbateggio = _interopRequireDefault(require("./22_group_2023_05_18/abbateggio"));

var _adelfia = _interopRequireDefault(require("./22_group_2023_05_18/adelfia"));

var _aglientu = _interopRequireDefault(require("./22_group_2023_05_18/aglientu"));

var _alfonsine = _interopRequireDefault(require("./22_group_2023_05_18/alfonsine"));

var _andora = _interopRequireDefault(require("./22_group_2023_05_18/andora"));

var _arcore = _interopRequireDefault(require("./22_group_2023_05_18/arcore"));

var _arenzano = _interopRequireDefault(require("./22_group_2023_05_18/arenzano"));

var _artena = _interopRequireDefault(require("./22_group_2023_05_18/artena"));

var _asolo = _interopRequireDefault(require("./22_group_2023_05_18/asolo"));

var _avezzano = _interopRequireDefault(require("./22_group_2023_05_18/avezzano"));

var _bagnoloInPiano = _interopRequireDefault(require("./22_group_2023_05_18/bagnolo-in-piano"));

var _baranoDIschia = _interopRequireDefault(require("./22_group_2023_05_18/barano-d-ischia"));

var _barga = _interopRequireDefault(require("./22_group_2023_05_18/barga"));

var _baronissi = _interopRequireDefault(require("./22_group_2023_05_18/baronissi"));

var _basciano = _interopRequireDefault(require("./22_group_2023_05_18/basciano"));

var _bedizzole = _interopRequireDefault(require("./22_group_2023_05_18/bedizzole"));

var _bellante = _interopRequireDefault(require("./22_group_2023_05_18/bellante"));

var _bomarzo = _interopRequireDefault(require("./22_group_2023_05_18/bomarzo"));

var _bomporto = _interopRequireDefault(require("./22_group_2023_05_18/bomporto"));

var _borgoMantovano = _interopRequireDefault(require("./22_group_2023_05_18/borgo-mantovano"));

var _borgoValDiTaro = _interopRequireDefault(require("./22_group_2023_05_18/borgo-val-di-taro"));

var _borgoVeneto = _interopRequireDefault(require("./22_group_2023_05_18/borgo-veneto"));

var _brunico = _interopRequireDefault(require("./22_group_2023_05_18/brunico"));

var _bucine = _interopRequireDefault(require("./22_group_2023_05_18/bucine"));

var _cadeo = _interopRequireDefault(require("./22_group_2023_05_18/cadeo"));

var _campelloSulClitunno = _interopRequireDefault(require("./22_group_2023_05_18/campello-sul-clitunno"));

var _campodarsego = _interopRequireDefault(require("./22_group_2023_05_18/campodarsego"));

var _campoformido = _interopRequireDefault(require("./22_group_2023_05_18/campoformido"));

var _campolongoMaggiore = _interopRequireDefault(require("./22_group_2023_05_18/campolongo-maggiore"));

var _capannori = _interopRequireDefault(require("./22_group_2023_05_18/capannori"));

var _capitignano = _interopRequireDefault(require("./22_group_2023_05_18/capitignano"));

var _caramanicoTerme = _interopRequireDefault(require("./22_group_2023_05_18/caramanico-terme"));

var _carbonia = _interopRequireDefault(require("./22_group_2023_05_18/carbonia"));

var _casalgrande = _interopRequireDefault(require("./22_group_2023_05_18/casalgrande"));

var _casalnuovoDiNapoli = _interopRequireDefault(require("./22_group_2023_05_18/casalnuovo-di-napoli"));

var _casatenovo = _interopRequireDefault(require("./22_group_2023_05_18/casatenovo"));

var _cascianaTermeLari = _interopRequireDefault(require("./22_group_2023_05_18/casciana-terme-lari"));

var _cassino = _interopRequireDefault(require("./22_group_2023_05_18/cassino"));

var _castelMaggiore = _interopRequireDefault(require("./22_group_2023_05_18/castel-maggiore"));

var _castelMorrone = _interopRequireDefault(require("./22_group_2023_05_18/castel-morrone"));

var _castelSanGiorgio = _interopRequireDefault(require("./22_group_2023_05_18/castel-san-giorgio"));

var _castelli = _interopRequireDefault(require("./22_group_2023_05_18/castelli"));

var _castelnuovoCilento = _interopRequireDefault(require("./22_group_2023_05_18/castelnuovo-cilento"));

var _castiglioneDelLago = _interopRequireDefault(require("./22_group_2023_05_18/castiglione-del-lago"));

var _castioneDellaPresolana = _interopRequireDefault(require("./22_group_2023_05_18/castione-della-presolana"));

var _castorano = _interopRequireDefault(require("./22_group_2023_05_18/castorano"));

var _cazzagoSanMartino = _interopRequireDefault(require("./22_group_2023_05_18/cazzago-san-martino"));

var _cellole = _interopRequireDefault(require("./22_group_2023_05_18/cellole"));

var _ceregnano = _interopRequireDefault(require("./22_group_2023_05_18/ceregnano"));

var _cerretoGuidi = _interopRequireDefault(require("./22_group_2023_05_18/cerreto-guidi"));

var _certaldo = _interopRequireDefault(require("./22_group_2023_05_18/certaldo"));

var _chiusa = _interopRequireDefault(require("./22_group_2023_05_18/chiusa"));

var _chiusaforte = _interopRequireDefault(require("./22_group_2023_05_18/chiusaforte"));

var _cittaSantAngelo = _interopRequireDefault(require("./22_group_2023_05_18/citta-sant-angelo"));

var _cittadella = _interopRequireDefault(require("./22_group_2023_05_18/cittadella"));

var _colliVerdi = _interopRequireDefault(require("./22_group_2023_05_18/colli-verdi"));

var _colognolaAiColli = _interopRequireDefault(require("./22_group_2023_05_18/colognola-ai-colli"));

var _cornaredo = _interopRequireDefault(require("./22_group_2023_05_18/cornaredo"));

var _desio = _interopRequireDefault(require("./22_group_2023_05_18/desio"));

var _eraclea = _interopRequireDefault(require("./22_group_2023_05_18/eraclea"));

var _fagagna = _interopRequireDefault(require("./22_group_2023_05_18/fagagna"));

var _fanano = _interopRequireDefault(require("./22_group_2023_05_18/fanano"));

var _faraInSabina = _interopRequireDefault(require("./22_group_2023_05_18/fara-in-sabina"));

var _faraVicentino = _interopRequireDefault(require("./22_group_2023_05_18/fara-vicentino"));

var _favignana = _interopRequireDefault(require("./22_group_2023_05_18/favignana"));

var _ferentillo = _interopRequireDefault(require("./22_group_2023_05_18/ferentillo"));

var _ferentino = _interopRequireDefault(require("./22_group_2023_05_18/ferentino"));

var _fermignano = _interopRequireDefault(require("./22_group_2023_05_18/fermignano"));

var _figlineEIncisaValdarno = _interopRequireDefault(require("./22_group_2023_05_18/figline-e-incisa-valdarno"));

var _finoMornasco = _interopRequireDefault(require("./22_group_2023_05_18/fino-mornasco"));

var _fontanellato = _interopRequireDefault(require("./22_group_2023_05_18/fontanellato"));

var _forio = _interopRequireDefault(require("./22_group_2023_05_18/forio"));

var _fossa = _interopRequireDefault(require("./22_group_2023_05_18/fossa"));

var _frontone = _interopRequireDefault(require("./22_group_2023_05_18/frontone"));

var _fucecchio = _interopRequireDefault(require("./22_group_2023_05_18/fucecchio"));

var _garbagnateMilanese = _interopRequireDefault(require("./22_group_2023_05_18/garbagnate-milanese"));

var _gavi = _interopRequireDefault(require("./22_group_2023_05_18/gavi"));

var _gavorrano = _interopRequireDefault(require("./22_group_2023_05_18/gavorrano"));

var _giulianova = _interopRequireDefault(require("./22_group_2023_05_18/giulianova"));

var _grado = _interopRequireDefault(require("./22_group_2023_05_18/grado"));

var _granaroloDellEmilia = _interopRequireDefault(require("./22_group_2023_05_18/granarolo-dell-emilia"));

var _gualdoTadino = _interopRequireDefault(require("./22_group_2023_05_18/gualdo-tadino"));

var _idro = _interopRequireDefault(require("./22_group_2023_05_18/idro"));

var _isolaDelLiri = _interopRequireDefault(require("./22_group_2023_05_18/isola-del-liri"));

var _laSpezia = _interopRequireDefault(require("./22_group_2023_05_18/la-spezia"));

var _laThuile = _interopRequireDefault(require("./22_group_2023_05_18/la-thuile"));

var _lampedusaELinosa = _interopRequireDefault(require("./22_group_2023_05_18/lampedusa-e-linosa"));

var _lamporecchio = _interopRequireDefault(require("./22_group_2023_05_18/lamporecchio"));

var _latisana = _interopRequireDefault(require("./22_group_2023_05_18/latisana"));

var _lattarico = _interopRequireDefault(require("./22_group_2023_05_18/lattarico"));

var _lauro = _interopRequireDefault(require("./22_group_2023_05_18/lauro"));

var _lettere = _interopRequireDefault(require("./22_group_2023_05_18/lettere"));

var _lipari = _interopRequireDefault(require("./22_group_2023_05_18/lipari"));

var _loiano = _interopRequireDefault(require("./22_group_2023_05_18/loiano"));

var _longobardi = _interopRequireDefault(require("./22_group_2023_05_18/longobardi"));

var _loreto = _interopRequireDefault(require("./22_group_2023_05_18/loreto"));

var _lozzoAtestino = _interopRequireDefault(require("./22_group_2023_05_18/lozzo-atestino"));

var _lugagnanoValDArda = _interopRequireDefault(require("./22_group_2023_05_18/lugagnano-val-d-arda"));

var _lusia = _interopRequireDefault(require("./22_group_2023_05_18/lusia"));

var _maccagnoConPinoEVeddasca = _interopRequireDefault(require("./22_group_2023_05_18/maccagno-con-pino-e-veddasca"));

var _manciano = _interopRequireDefault(require("./22_group_2023_05_18/manciano"));

var _maratea = _interopRequireDefault(require("./22_group_2023_05_18/maratea"));

var _matera = _interopRequireDefault(require("./22_group_2023_05_18/matera"));

var _meltina = _interopRequireDefault(require("./22_group_2023_05_18/meltina"));

var _mezzanego = _interopRequireDefault(require("./22_group_2023_05_18/mezzanego"));

var _mirandola = _interopRequireDefault(require("./22_group_2023_05_18/mirandola"));

var _montagnana = _interopRequireDefault(require("./22_group_2023_05_18/montagnana"));

var _montecorvinoRovella = _interopRequireDefault(require("./22_group_2023_05_18/montecorvino-rovella"));

var _montefiorino = _interopRequireDefault(require("./22_group_2023_05_18/montefiorino"));

var _montegranaro = _interopRequireDefault(require("./22_group_2023_05_18/montegranaro"));

var _montelibretti = _interopRequireDefault(require("./22_group_2023_05_18/montelibretti"));

var _montoro = _interopRequireDefault(require("./22_group_2023_05_18/montoro"));

var _morroDAlba = _interopRequireDefault(require("./22_group_2023_05_18/morro-d-alba"));

var _nalles = _interopRequireDefault(require("./22_group_2023_05_18/nalles"));

var _nemi = _interopRequireDefault(require("./22_group_2023_05_18/nemi"));

var _nonantola = _interopRequireDefault(require("./22_group_2023_05_18/nonantola"));

var _noventaVicentina = _interopRequireDefault(require("./22_group_2023_05_18/noventa-vicentina"));

var _numana = _interopRequireDefault(require("./22_group_2023_05_18/numana"));

var _oderzo = _interopRequireDefault(require("./22_group_2023_05_18/oderzo"));

var _oggiono = _interopRequireDefault(require("./22_group_2023_05_18/oggiono"));

var _orero = _interopRequireDefault(require("./22_group_2023_05_18/orero"));

var _ortaSanGiulio = _interopRequireDefault(require("./22_group_2023_05_18/orta-san-giulio"));

var _otranto = _interopRequireDefault(require("./22_group_2023_05_18/otranto"));

var _ottaviano = _interopRequireDefault(require("./22_group_2023_05_18/ottaviano"));

var _pagnacco = _interopRequireDefault(require("./22_group_2023_05_18/pagnacco"));

var _pero = _interopRequireDefault(require("./22_group_2023_05_18/pero"));

var _pettenasco = _interopRequireDefault(require("./22_group_2023_05_18/pettenasco"));

var _pianeCrati = _interopRequireDefault(require("./22_group_2023_05_18/piane-crati"));

var _pianoro = _interopRequireDefault(require("./22_group_2023_05_18/pianoro"));

var _pietrasanta = _interopRequireDefault(require("./22_group_2023_05_18/pietrasanta"));

var _poggioBustone = _interopRequireDefault(require("./22_group_2023_05_18/poggio-bustone"));

var _polesineZibello = _interopRequireDefault(require("./22_group_2023_05_18/polesine-zibello"));

var _pontassieve = _interopRequireDefault(require("./22_group_2023_05_18/pontassieve"));

var _ponteNelleAlpi = _interopRequireDefault(require("./22_group_2023_05_18/ponte-nelle-alpi"));

var _ponteSanPietro = _interopRequireDefault(require("./22_group_2023_05_18/ponte-san-pietro"));

var _pontinia = _interopRequireDefault(require("./22_group_2023_05_18/pontinia"));

var _ponzanoVeneto = _interopRequireDefault(require("./22_group_2023_05_18/ponzano-veneto"));

var _praiaAMare = _interopRequireDefault(require("./22_group_2023_05_18/praia-a-mare"));

var _pratella = _interopRequireDefault(require("./22_group_2023_05_18/pratella"));

var _predappio = _interopRequireDefault(require("./22_group_2023_05_18/predappio"));

var _preganziol = _interopRequireDefault(require("./22_group_2023_05_18/preganziol"));

var _priverno = _interopRequireDefault(require("./22_group_2023_05_18/priverno"));

var _ragusa = _interopRequireDefault(require("./22_group_2023_05_18/ragusa"));

var _rapolanoTerme = _interopRequireDefault(require("./22_group_2023_05_18/rapolano-terme"));

var _ravello = _interopRequireDefault(require("./22_group_2023_05_18/ravello"));

var _ricadi = _interopRequireDefault(require("./22_group_2023_05_18/ricadi"));

var _rio = _interopRequireDefault(require("./22_group_2023_05_18/rio"));

var _rivaDelPo = _interopRequireDefault(require("./22_group_2023_05_18/riva-del-po"));

var _robecchettoConInduno = _interopRequireDefault(require("./22_group_2023_05_18/robecchetto-con-induno"));

var _roccaDiPapa = _interopRequireDefault(require("./22_group_2023_05_18/rocca-di-papa"));

var _roccarainola = _interopRequireDefault(require("./22_group_2023_05_18/roccarainola"));

var _salo = _interopRequireDefault(require("./22_group_2023_05_18/salo"));

var _sanDemetrioNeVestini = _interopRequireDefault(require("./22_group_2023_05_18/san-demetrio-ne-vestini"));

var _sanFeliceACancello = _interopRequireDefault(require("./22_group_2023_05_18/san-felice-a-cancello"));

var _sanFeliceDelBenaco = _interopRequireDefault(require("./22_group_2023_05_18/san-felice-del-benaco"));

var _sanGiustino = _interopRequireDefault(require("./22_group_2023_05_18/san-giustino"));

var _sanLazzaroDiSavena = _interopRequireDefault(require("./22_group_2023_05_18/san-lazzaro-di-savena"));

var _sanMarcelloPiteglio = _interopRequireDefault(require("./22_group_2023_05_18/san-marcello-piteglio"));

var _sanMartinoDiLupari = _interopRequireDefault(require("./22_group_2023_05_18/san-martino-di-lupari"));

var _sanNicolaArcella = _interopRequireDefault(require("./22_group_2023_05_18/san-nicola-arcella"));

var _santAntimo = _interopRequireDefault(require("./22_group_2023_05_18/sant-antimo"));

var _santaMariaAMonte = _interopRequireDefault(require("./22_group_2023_05_18/santa-maria-a-monte"));

var _santaMariaDelCedro = _interopRequireDefault(require("./22_group_2023_05_18/santa-maria-del-cedro"));

var _santiCosmaEDamiano = _interopRequireDefault(require("./22_group_2023_05_18/santi-cosma-e-damiano"));

var _saonara = _interopRequireDefault(require("./22_group_2023_05_18/saonara"));

var _sarno = _interopRequireDefault(require("./22_group_2023_05_18/sarno"));

var _sassofeltrio = _interopRequireDefault(require("./22_group_2023_05_18/sassofeltrio"));

var _savignanoSulPanaro = _interopRequireDefault(require("./22_group_2023_05_18/savignano-sul-panaro"));

var _scala = _interopRequireDefault(require("./22_group_2023_05_18/scala"));

var _scandicci = _interopRequireDefault(require("./22_group_2023_05_18/scandicci"));

var _scisciano = _interopRequireDefault(require("./22_group_2023_05_18/scisciano"));

var _serramazzoni = _interopRequireDefault(require("./22_group_2023_05_18/serramazzoni"));

var _sestola = _interopRequireDefault(require("./22_group_2023_05_18/sestola"));

var _spezzanoDellaSila = _interopRequireDefault(require("./22_group_2023_05_18/spezzano-della-sila"));

var _stanghella = _interopRequireDefault(require("./22_group_2023_05_18/stanghella"));

var _susegana = _interopRequireDefault(require("./22_group_2023_05_18/susegana"));

var _tarquinia = _interopRequireDefault(require("./22_group_2023_05_18/tarquinia"));

var _teolo = _interopRequireDefault(require("./22_group_2023_05_18/teolo"));

var _terranuovaBracciolini = _interopRequireDefault(require("./22_group_2023_05_18/terranuova-bracciolini"));

var _terzoDAquileia = _interopRequireDefault(require("./22_group_2023_05_18/terzo-d-aquileia"));

var _tezzeSulBrenta = _interopRequireDefault(require("./22_group_2023_05_18/tezze-sul-brenta"));

var _todi = _interopRequireDefault(require("./22_group_2023_05_18/todi"));

var _torritaDiSiena = _interopRequireDefault(require("./22_group_2023_05_18/torrita-di-siena"));

var _tremezzina = _interopRequireDefault(require("./22_group_2023_05_18/tremezzina"));

var _treppoGrande = _interopRequireDefault(require("./22_group_2023_05_18/treppo-grande"));

var _treppoLigosullo = _interopRequireDefault(require("./22_group_2023_05_18/treppo-ligosullo"));

var _trevignano = _interopRequireDefault(require("./22_group_2023_05_18/trevignano"));

var _tricase = _interopRequireDefault(require("./22_group_2023_05_18/tricase"));

var _uzzano = _interopRequireDefault(require("./22_group_2023_05_18/uzzano"));

var _vairanoPatenora = _interopRequireDefault(require("./22_group_2023_05_18/vairano-patenora"));

var _valDiNizza = _interopRequireDefault(require("./22_group_2023_05_18/val-di-nizza"));

var _valderice = _interopRequireDefault(require("./22_group_2023_05_18/valderice"));

var _valdilana = _interopRequireDefault(require("./22_group_2023_05_18/valdilana"));

var _valfurva = _interopRequireDefault(require("./22_group_2023_05_18/valfurva"));

var _valsamoggia = _interopRequireDefault(require("./22_group_2023_05_18/valsamoggia"));

var _vergato = _interopRequireDefault(require("./22_group_2023_05_18/vergato"));

var _vicoEquense = _interopRequireDefault(require("./22_group_2023_05_18/vico-equense"));

var _vicopisano = _interopRequireDefault(require("./22_group_2023_05_18/vicopisano"));

var _vietriSulMare = _interopRequireDefault(require("./22_group_2023_05_18/vietri-sul-mare"));

var _vigonza = _interopRequireDefault(require("./22_group_2023_05_18/vigonza"));

var _zogno = _interopRequireDefault(require("./22_group_2023_05_18/zogno"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _abbateggio["default"], {}, _adelfia["default"], {}, _aglientu["default"], {}, _alfonsine["default"], {}, _andora["default"], {}, _arcore["default"], {}, _arenzano["default"], {}, _artena["default"], {}, _asolo["default"], {}, _avezzano["default"], {}, _bagnoloInPiano["default"], {}, _baranoDIschia["default"], {}, _barga["default"], {}, _baronissi["default"], {}, _basciano["default"], {}, _bedizzole["default"], {}, _bellante["default"], {}, _bomarzo["default"], {}, _bomporto["default"], {}, _borgoMantovano["default"], {}, _borgoValDiTaro["default"], {}, _borgoVeneto["default"], {}, _brunico["default"], {}, _bucine["default"], {}, _cadeo["default"], {}, _campelloSulClitunno["default"], {}, _campodarsego["default"], {}, _campoformido["default"], {}, _campolongoMaggiore["default"], {}, _capannori["default"], {}, _capitignano["default"], {}, _caramanicoTerme["default"], {}, _carbonia["default"], {}, _casalgrande["default"], {}, _casalnuovoDiNapoli["default"], {}, _casatenovo["default"], {}, _cascianaTermeLari["default"], {}, _cassino["default"], {}, _castelMaggiore["default"], {}, _castelMorrone["default"], {}, _castelSanGiorgio["default"], {}, _castelli["default"], {}, _castelnuovoCilento["default"], {}, _castiglioneDelLago["default"], {}, _castioneDellaPresolana["default"], {}, _castorano["default"], {}, _cazzagoSanMartino["default"], {}, _cellole["default"], {}, _ceregnano["default"], {}, _cerretoGuidi["default"], {}, _certaldo["default"], {}, _chiusa["default"], {}, _chiusaforte["default"], {}, _cittaSantAngelo["default"], {}, _cittadella["default"], {}, _colliVerdi["default"], {}, _colognolaAiColli["default"], {}, _cornaredo["default"], {}, _desio["default"], {}, _eraclea["default"], {}, _fagagna["default"], {}, _fanano["default"], {}, _faraInSabina["default"], {}, _faraVicentino["default"], {}, _favignana["default"], {}, _ferentillo["default"], {}, _ferentino["default"], {}, _fermignano["default"], {}, _figlineEIncisaValdarno["default"], {}, _finoMornasco["default"], {}, _fontanellato["default"], {}, _forio["default"], {}, _fossa["default"], {}, _frontone["default"], {}, _fucecchio["default"], {}, _garbagnateMilanese["default"], {}, _gavi["default"], {}, _gavorrano["default"], {}, _giulianova["default"], {}, _grado["default"], {}, _granaroloDellEmilia["default"], {}, _gualdoTadino["default"], {}, _idro["default"], {}, _isolaDelLiri["default"], {}, _laSpezia["default"], {}, _laThuile["default"], {}, _lampedusaELinosa["default"], {}, _lamporecchio["default"], {}, _latisana["default"], {}, _lattarico["default"], {}, _lauro["default"], {}, _lettere["default"], {}, _lipari["default"], {}, _loiano["default"], {}, _longobardi["default"], {}, _loreto["default"], {}, _lozzoAtestino["default"], {}, _lugagnanoValDArda["default"], {}, _lusia["default"], {}, _maccagnoConPinoEVeddasca["default"], {}, _manciano["default"], {}, _maratea["default"], {}, _matera["default"], {}, _meltina["default"], {}, _mezzanego["default"], {}, _mirandola["default"], {}, _montagnana["default"], {}, _montecorvinoRovella["default"], {}, _montefiorino["default"], {}, _montegranaro["default"], {}, _montelibretti["default"], {}, _montoro["default"], {}, _morroDAlba["default"], {}, _nalles["default"], {}, _nemi["default"], {}, _nonantola["default"], {}, _noventaVicentina["default"], {}, _numana["default"], {}, _oderzo["default"], {}, _oggiono["default"], {}, _orero["default"], {}, _ortaSanGiulio["default"], {}, _otranto["default"], {}, _ottaviano["default"], {}, _pagnacco["default"], {}, _pero["default"], {}, _pettenasco["default"], {}, _pianeCrati["default"], {}, _pianoro["default"], {}, _pietrasanta["default"], {}, _poggioBustone["default"], {}, _polesineZibello["default"], {}, _pontassieve["default"], {}, _ponteNelleAlpi["default"], {}, _ponteSanPietro["default"], {}, _pontinia["default"], {}, _ponzanoVeneto["default"], {}, _praiaAMare["default"], {}, _pratella["default"], {}, _predappio["default"], {}, _preganziol["default"], {}, _priverno["default"], {}, _ragusa["default"], {}, _rapolanoTerme["default"], {}, _ravello["default"], {}, _ricadi["default"], {}, _rio["default"], {}, _rivaDelPo["default"], {}, _robecchettoConInduno["default"], {}, _roccaDiPapa["default"], {}, _roccarainola["default"], {}, _salo["default"], {}, _sanDemetrioNeVestini["default"], {}, _sanFeliceACancello["default"], {}, _sanFeliceDelBenaco["default"], {}, _sanGiustino["default"], {}, _sanLazzaroDiSavena["default"], {}, _sanMarcelloPiteglio["default"], {}, _sanMartinoDiLupari["default"], {}, _sanNicolaArcella["default"], {}, _santAntimo["default"], {}, _santaMariaAMonte["default"], {}, _santaMariaDelCedro["default"], {}, _santiCosmaEDamiano["default"], {}, _saonara["default"], {}, _sarno["default"], {}, _sassofeltrio["default"], {}, _savignanoSulPanaro["default"], {}, _scala["default"], {}, _scandicci["default"], {}, _scisciano["default"], {}, _serramazzoni["default"], {}, _sestola["default"], {}, _spezzanoDellaSila["default"], {}, _stanghella["default"], {}, _susegana["default"], {}, _tarquinia["default"], {}, _teolo["default"], {}, _terranuovaBracciolini["default"], {}, _terzoDAquileia["default"], {}, _tezzeSulBrenta["default"], {}, _todi["default"], {}, _torritaDiSiena["default"], {}, _tremezzina["default"], {}, _treppoGrande["default"], {}, _treppoLigosullo["default"], {}, _trevignano["default"], {}, _tricase["default"], {}, _uzzano["default"], {}, _vairanoPatenora["default"], {}, _valDiNizza["default"], {}, _valderice["default"], {}, _valdilana["default"], {}, _valfurva["default"], {}, _valsamoggia["default"], {}, _vergato["default"], {}, _vicoEquense["default"], {}, _vicopisano["default"], {}, _vietriSulMare["default"], {}, _vigonza["default"], {}, _zogno["default"]);

exports["default"] = _default;